// extracted by mini-css-extract-plugin
module.exports = {"DndIndicator":"_1IGbgLp1QaeJlEfyS_-Txj","DndIcon":"_1tVYAMNp_iGr8HhI1btTHE"};